<template>
  <div class="shop-couponCode">
    <Search :renderData="renderData" :formData="form" :labelWidth="100"  @onSearch="onSearch">
    </Search>
    <div class="fun-btn-box">
       <auth-button auth="finance:coupon:code:download">
          <el-button type="primary"  @click="()=>{this.isShowExportDialog = true}" :loading="exportLoading">下载券码</el-button>
        </auth-button>
        <auth-button auth="finance:coupon:old:wirteoff:download" style="margin-left:20px;">
          <el-button type="primary"  @click="onOldExport" :loading="exportLoading">华润核销码</el-button>
        </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #names="{ row }">{{ row.names.split(',').slice(0,2).join(',') }}
        <el-button  v-if="row.names.split(',').length>2" type="text" @click="onShowShop(row)" style="margin-left:10px;">更多</el-button>
      </template>
      <template #quantity="{ row }">{{ row.quantity }}</template>
      <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operation="{ scope }">
        <auth-button auth="finance:coupon:wirteoff:download">
          <el-button type="text"  @click="onRecordsExport(scope.row)" class="mr10">下载核销记录</el-button >
        </auth-button>
      </template>
    </Table>
     <el-dialog :visible="isShowExportDialog" title="下载券码"  width="25%"  :before-close="onCleanExport"  class="isShowExportDialog">
      <el-form ref="exportForm" :model="exportForm"  :rules="rules" label-width="80px" >
        <el-form-item label="关联店铺"  prop="storeIds">
          <el-select v-model="exportForm.storeIds" placeholder="请选择店铺" multiple  filterable collapse-tags :disabled="exportLoading" @change="onStoreChange">
              <el-option label="全部" value="ALL"></el-option>
              <el-option v-for="(item,index) in exportForm.storeList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="下载数量" prop="quantity">
            <el-input v-model="exportForm.quantity" placeholder="请输入下载数量" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" maxLength="4" :disabled="exportLoading" >
                <template slot="append">张</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <span class="prompt">下载数量不能超过5000</span>
          </el-form-item>
       </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCleanExport">取 消</el-button>
            <el-button type="primary" @click="onExport" :loading="exportLoading">{{exportLoading?'下载中...':'提 交'}}</el-button>
        </div>
    </el-dialog>  
     <el-dialog :visible="isShowShopDialog" title="查看店铺"  width="30%"  :before-close="() => this.isShowShopDialog = false"  class="isShowShopDialog">
         <div class="content">
           <p v-for="(item,index) in shoplist" :key="index">{{item}}</p> 
         </div>
    </el-dialog>  
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { downFile } from "@/utils";
import { api_getCouponCodeList,api_postCouponCodeExport,api_postCouponCodeRecordExport,api_postCouponCodeOldExport} from '@/api/finance'
import { api_getStoreList } from '@/api/integral'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "fShopCouponCode",
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    // 校验表格中的输入框
    const checkForm = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入下载数量'))
      } else if(value>5000){
        callback(new Error('下载数量不能超过5000'))
      }else{
         callback()
      }
    }
    return {
      renderData: [
        {
          label: "店铺名称",
          placeholder: "请选择店铺名称",
          type: "select",
          key: "storeIds",
          option:[],
          multiple:true,
        },
        {
          label: "下载时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
      ],
      form: {},
      exportLoading: false,
      isShowExportDialog:false,
      isShowShopDialog:false,
      exportForm:{
        storeList:[],
        storeIds:[]
      },
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      checkForm,
      shoplist:[],
      tableList:[],
      tableThData: [
        { prop: "names", label: "店铺名称", minWidth: "180", },
        { prop: "updated", label: "下载时间", minWidth: "180", },
        { prop: "quantity", label: "下载数量", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "160", },
      ],
      rules: {
        storeIds: [{ required: true, message: '请选择店铺' }],
        quantity: [{ required: true, validator: checkForm  }],
      },
    };
  },
  created () {
    this.getStoreData()
    this.getQueryUrl()
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.startTime = this.form.time ? this.form.time[0] : undefined
      params.endTime = this.form.time ? this.form.time[1] : undefined
      delete params.time
      const data = await api_getCouponCodeList(params)
      this.tableList = this.group(data, 10);
      this.tableTrData = this.tableList[this.offset/10] || []
      this.total = data.length
      this.loading = false
    },
    // 获取店铺数据
    async getStoreData() {
      let res = await api_getStoreList()
      let arr = res.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
      this.renderData[0].option = arr
      this.exportForm.storeList = arr
    },
    // 点击查看店铺
    async onShowShop(row) {
     this.isShowShopDialog = true
     this.shoplist = row.names.split(',')
    },
    // 下载券码弹窗关闭且清空输入项
    onCleanExport(){
        this.isShowExportDialog = false
        this.$refs.exportForm.resetFields();
    },
    //下载券码
     async onExport() {
      this.$refs.exportForm.validate(async (valid) => {
        if (valid) {
          this.exportLoading = true
          const params = {
            ...this.exportForm,
          }
          try{
            let res = await api_postCouponCodeExport(params)
            downFile(res)
            this.onCleanExport()
            this.$baseMessage('下载成功', 'success')
          
          }catch(error){
            this.$baseMessage('下载失败', 'error')
          }
          this.exportLoading = false
          this.getList()  
        }
      })
    },
    
    //下载核销记录
    async onRecordsExport(row) {
      this.$baseConfirm(
        '是否确认下载核销记录？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          const params = {
          refId:row.refId
          }
          let res = await api_postCouponCodeRecordExport(params)
          downFile(res)
          this.$baseMessage('下载成功', 'success')
        }
      )
    },
     //下载核销记录
    async onOldExport(row) {
      this.$baseConfirm(
        '是否确认下载华润核销码？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          const params = {
          refId:row.refId
          }
          let res = await api_postCouponCodeOldExport(params)
          downFile(res)
          this.$baseMessage('下载成功', 'success')
        }
      )
    },
    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },
    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },
    getQueryUrl() {
      const { offset, limit } = this.$route.query
      // 处理数组形式参数
      this.form = {...this.form,...this.$route.query}
      offset && (this.offset = parseInt(offset))
      limit && (this.limit = parseInt(limit))
    },
     // 商场下拉框改变
    onStoreChange(data) {
      if (data.indexOf('ALL') >= 0) {
      this.exportForm.storeIds = this.exportForm.storeList.map((item)=>{
          return item.value
        })
      }
      console.log(this.exportForm.storeIds)
    },
    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
  },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.shop-couponCode{
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .prompt{
    font-size: 12px;
    color: #999999;
  }
  /deep/ .isShowExportDialog{
      .el-select {
        width: 100%;
        margin-right: 2px;
      }
      .el-input {
        width: 100%;
      }
  }
  .isShowShopDialog{
      .content{
         min-height: 300px;
         max-height: 500px;
         width: 100%;
         margin: auto;
         align-items: center;
         text-align: center;
         overflow-y: auto;
      }
  }
}
</style>
